import type {
  CellType,
  ElementType,
  ImageType,
  MultipleSelectionType as BaseMultipleSelectionType,
  OptionType,
  SingleSelectionType,
  TextareaType,
  TypographyType,
} from "./CellComponent";

export type {
  CellType,
  ElementType,
  ImageType,
  OptionType,
  SingleSelectionType,
  TextareaType,
  TypographyType,
};

export interface MultipleSelectionType extends BaseMultipleSelectionType {
  correctOptionIndices?: number[];
  incorrectMessage?: string;
}

export function Typography(
  translationKey: string,
  arg?: TypographyType
): { type: "typography"; content: TypographyType } {
  return {
    type: "typography",
    content: {
      translationKey,
      ...(arg && arg),
    },
  };
}

export function Textarea(arg?: TextareaType): {
  type: "textarea";
  content: TextareaType;
} {
  return {
    type: "textarea",
    content: { ...(arg && arg) },
  };
}

export function ButtonGroup(
  options: OptionType[],
  arg?: SingleSelectionType
): { type: "buttongroup"; content: SingleSelectionType } {
  return {
    type: "buttongroup",
    content: {
      options,
      ...(arg && arg),
    },
  };
}

export function ButtonGroupMultipleChoice(
  options: OptionType[],
  arg?: MultipleSelectionType
): { type: "buttongroup_multipleChoice"; content: MultipleSelectionType } {
  return {
    type: "buttongroup_multipleChoice",
    content: {
      options,
      ...(arg && arg),
    },
  };
}

export function Image(url: string): { type: "image"; content: ImageType } {
  return {
    type: "image",
    content: {
      imageUrl: url,
    },
  };
}

export function DividerLine(
  arg?: TypographyType
): { type: "divider"; content: ElementType }[] {
  return [
    {
      type: "divider",
      content: { ...(arg && arg) },
    },
  ];
}

export function TypographyLine(
  text: string,
  arg?: TypographyType
): { type: "typography"; content: TypographyType }[] {
  return [Typography(text, arg)];
}
